// test1489
(1489 && 0);
